<script setup>
import { onMounted, onBeforeUnmount } from "vue";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

onMounted(() => {
  am4core.useTheme(am4themes_animated);

  let chart = am4core.create("chartdiv", am4charts.XYChart);
  chart.colors.step = 2;
  chart.maskBullets = false;

  chart.data = [
    { date: "2024-01-01", distance: 7, duration: 18, metric3: 5 },
    { date: "2024-01-02", distance: 6, duration: 20, metric3: 7 },
    { date: "2024-01-03", distance: 9, duration: 22, metric3: 4 },
    { date: "2024-01-04", distance: 8, duration: 19, metric3: 6 },
    { date: "2024-01-05", distance: 7, duration: 21, metric3: 5 },
    { date: "2024-01-06", distance: 5, duration: 17, metric3: 8 },
    { date: "2024-01-07", distance: 9, duration: 23, metric3: 7 },
  ];

  let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
  dateAxis.renderer.minGridDistance = 50;
  dateAxis.renderer.fullWidthTooltip = true;

  let distanceAxis = chart.yAxes.push(new am4charts.ValueAxis());
  distanceAxis.title.text = "Values";

  // Yellow Bars
  let distanceSeries = chart.series.push(new am4charts.ColumnSeries());
  distanceSeries.dataFields.valueY = "distance";
  distanceSeries.dataFields.dateX = "date";
  distanceSeries.name = "Distance";
  distanceSeries.tooltipText = "{valueY}";
  distanceSeries.columns.template.fill = am4core.color("#F8B400"); // Yellow
  distanceSeries.columns.template.stroke = am4core.color("#F8B400");
  distanceSeries.columns.template.fillOpacity = 0.8;

  // Blue Line
  let durationSeries = chart.series.push(new am4charts.LineSeries());
  durationSeries.dataFields.valueY = "duration";
  durationSeries.dataFields.dateX = "date";
  durationSeries.name = "Duration";
  durationSeries.strokeWidth = 2;
  durationSeries.stroke = am4core.color("#007bff"); // Blue
  durationSeries.tooltipText = "{valueY}";

  let durationBullet = durationSeries.bullets.push(new am4charts.CircleBullet());
  durationBullet.circle.fill = am4core.color("#007bff");
  durationBullet.circle.strokeWidth = 2;

  // Black Line
  let metric3Series = chart.series.push(new am4charts.LineSeries());
  metric3Series.dataFields.valueY = "metric3";
  metric3Series.dataFields.dateX = "date";
  metric3Series.name = "Metric 3";
  metric3Series.strokeWidth = 2;
  metric3Series.stroke = am4core.color("#000000"); // Black
  metric3Series.tooltipText = "{valueY}";

  let metric3Bullet = metric3Series.bullets.push(new am4charts.CircleBullet());
  metric3Bullet.circle.fill = am4core.color("#000000");
  metric3Bullet.circle.strokeWidth = 2;

  // Purple Line
  let metric4Series = chart.series.push(new am4charts.LineSeries());
  metric4Series.dataFields.valueY = "metric3";
  metric4Series.dataFields.dateX = "date";
  metric4Series.name = "Metric 4";
  metric4Series.strokeWidth = 2;
  metric4Series.stroke = am4core.color("#800080"); // Purple
  metric4Series.tooltipText = "{valueY}";

  let metric4Bullet = metric4Series.bullets.push(new am4charts.CircleBullet());
  metric4Bullet.circle.fill = am4core.color("#800080");
  metric4Bullet.circle.strokeWidth = 2;

  chart.legend = new am4charts.Legend();
  chart.cursor = new am4charts.XYCursor();

  chart.logo.disabled = true;

  // Cleanup
  onBeforeUnmount(() => {
    if (chart) {
      chart.dispose();
    }
  });
});
</script>

<template>
  <div id="chartdiv" style="width: 100%; height: 500px"></div>
</template>
